import { schema } from "normalizr"

const quotationSchema = new schema.Entity("quotations")

export default quotationSchema
